const translations = {
  en: {
    depositUsingZelle: 'Deposit using Zelle',
    instructions: 'INSTRUCTIONS',
    step1: 'Enter the deposit amount.',
    step2Prefix: 'Once you click',
    step2Button: 'NEXT',
    step2Suffix: 'you will receive a confirmation code by email and SMS.',
    step2Note: '(You will need this code when making the deposit)',
    step3: 'Make the deposit for the amount entered via ZELLE by using your Online Banking App or ZELLE App.',
    step3Note: '(ZELLE App is available on Apple App Store or Google Play Store)',
    currency: 'Currency',
    amountPlaceholder: 'Amount',
    depositLimits: 'Deposit Limits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    back: 'BACK',
    next: 'NEXT',
    finish: 'FINISH',
    zelleLabel: 'ZELLE:',
    payableTo: 'Payable to:',
    codeLabel: 'Code:',
    messageOrMemo: 'Message or Memo:',
    confirmationCodePrefix: 'Your Confirmation Code is',
    confirmationCodeSuffix: '. Please make sure to include ONLY this code in the "MESSAGE" or "MEMO" field when making your deposit, or else your deposit will not be credited.',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
    errorBankAccounts: 'Error bank accounts',
    errorInitiateTransaction: 'Error initiate transaction',
    noZelleAccounts: 'No Zelle accounts available from provider.',
    errorWithEwalletDeposit: 'Error with eWallet Deposit',
    depositRejected: 'eWallet Deposit Rejected',
  },
  es: {
    depositUsingZelle: 'Depositar usando Zelle',
    instructions: 'INSTRUCCIONES',
    step1: 'Ingrese el monto del depósito.',
    step2Prefix: 'Al hacer clic en',
    step2Button: 'SIGUIENTE',
    step2Suffix: 'recibirá un código de confirmación por correo electrónico y SMS.',
    step2Note: '(Necesitará este código al realizar el depósito)',
    step3: 'Realice el depósito por el monto ingresado a través de ZELLE usando su App de Banca en Línea o la App ZELLE.',
    step3Note: '(La App ZELLE está disponible en Apple App Store o Google Play Store)',
    currency: 'Moneda',
    amountPlaceholder: 'Monto',
    depositLimits: 'Límites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    back: 'ATRÁS',
    next: 'SIGUIENTE',
    finish: 'FINALIZAR',
    zelleLabel: 'ZELLE:',
    payableTo: 'Pagar a:',
    codeLabel: 'Código:',
    messageOrMemo: 'Mensaje o Memo:',
    confirmationCodePrefix: 'Su Código de Confirmación es',
    confirmationCodeSuffix: '. Por favor asegúrese de incluir SOLO este código en el campo "MENSAJE" o "MEMO" al realizar su depósito, de lo contrario su depósito no será acreditado.',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
    errorBankAccounts: 'Error en cuentas bancarias',
    errorInitiateTransaction: 'Error al iniciar la transacción',
    noZelleAccounts: 'No hay cuentas Zelle disponibles del proveedor.',
    errorWithEwalletDeposit: 'Error con el Depósito eWallet',
    depositRejected: 'Depósito eWallet Rechazado',
  },
  pt: {
    depositUsingZelle: 'Depositar usando Zelle',
    instructions: 'INSTRUÇÕES',
    step1: 'Insira o valor do depósito.',
    step2Prefix: 'Ao clicar em',
    step2Button: 'PRÓXIMO',
    step2Suffix: 'você receberá um código de confirmação por e-mail e SMS.',
    step2Note: '(Você precisará deste código ao fazer o depósito)',
    step3: 'Faça o depósito do valor inserido via ZELLE usando seu App de Banco Online ou o App ZELLE.',
    step3Note: '(O App ZELLE está disponível na Apple App Store ou Google Play Store)',
    currency: 'Moeda',
    amountPlaceholder: 'Valor',
    depositLimits: 'Limites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    back: 'VOLTAR',
    next: 'PRÓXIMO',
    finish: 'FINALIZAR',
    zelleLabel: 'ZELLE:',
    payableTo: 'Pagar a:',
    codeLabel: 'Código:',
    messageOrMemo: 'Mensagem ou Memo:',
    confirmationCodePrefix: 'Seu Código de Confirmação é',
    confirmationCodeSuffix: '. Por favor, certifique-se de incluir APENAS este código no campo "MENSAGEM" ou "MEMO" ao fazer seu depósito, caso contrário seu depósito não será creditado.',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
    errorBankAccounts: 'Erro em contas bancárias',
    errorInitiateTransaction: 'Erro ao iniciar a transação',
    noZelleAccounts: 'Não há contas Zelle disponíveis do provedor.',
    errorWithEwalletDeposit: 'Erro com Depósito eWallet',
    depositRejected: 'Depósito eWallet Rejeitado',
  },
}

export default translations
